var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447717 0.447715 0 1 0H9.66667C10.219 0 10.6667 0.447715 10.6667 1V8.66667C10.6667 9.77123 9.77124 10.6667 8.66667 10.6667H2C0.895432 10.6667 0 9.77124 0 8.66667V1Z",
    fill: "#28AF4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 14.332C13.332 13.7797 13.7797 13.332 14.332 13.332H22.9987C23.551 13.332 23.9987 13.7797 23.9987 14.332V21.9987C23.9987 23.1033 23.1033 23.9987 21.9987 23.9987H15.332C14.2275 23.9987 13.332 23.1033 13.332 21.9987V14.332Z",
    fill: "#28AF4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.332C0 15.1229 1.79086 13.332 4 13.332H6.66666C8.8758 13.332 10.6667 15.1229 10.6667 17.332V19.9987C10.6667 22.2078 8.87581 23.9987 6.66667 23.9987H4C1.79086 23.9987 0 22.2078 0 19.9987V17.332Z",
    fill: "#28AF4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 4C13.332 1.79086 15.1229 0 17.332 0H19.9987C22.2078 0 23.9987 1.79086 23.9987 4V6.66666C23.9987 8.8758 22.2078 10.6667 19.9987 10.6667H17.332C15.1229 10.6667 13.332 8.87581 13.332 6.66667V4Z",
    fill: "#28AF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryImage);
export default __webpack_public_path__ + "static/media/CategoryImage.62d2280ddf0c710a4e40c077e3df0f73.svg";
export { ForwardRef as ReactComponent };